<a
  #link
  [ngClass]="classNames$ | async"
  [routerLink]="href$ | async"
  [routerLinkActive]="routerLinkActive"
  [routerLinkActiveOptions]="{ exact: routerLinkActiveExact }"
  (click)="updateReturnToAddress()"
>
  <!-- When using content projection it can happen that spaces around the simple string are also projected and that is not what's expected. That's why we have the option to use a value property or content projection. -->
  @if (value == null) {
    <ng-content></ng-content>
  } @else {
    {{ value }}
  }
</a>
